// Burger __________________________________________________________________________________
(function () {
    const body = document.body;
    const header = document.querySelector('header');

    // mobile drawer існуюче
    const burger = document.getElementById('burger');
    const line1 = document.getElementById('b1');
    const line2 = document.getElementById('b2');
    const drawer = document.getElementById('mobile-drawer');

    // NEW: кнопка Close у мобільному меню
    const closeBtn = document.getElementById('closeBurger');

    function openDrawer() {
        drawer.classList.remove('-translate-x-full');
        body.classList.add('overflow-hidden');
        burger.setAttribute('aria-expanded', 'true');

        line1.classList.remove('-translate-y-[6px]', 'rotate-0');
        line2.classList.remove('translate-y-[6px]', 'rotate-0', 'w-5', '-translate-x-1/3');

        line1.classList.add('translate-y-0', 'rotate-45');
        line2.classList.add('translate-y-0', '-rotate-45', 'w-7', '-translate-x-1/2');
    }

    function closeDrawer() {
        drawer.classList.add('-translate-x-full');
        body.classList.remove('overflow-hidden');
        burger.setAttribute('aria-expanded', 'false');

        line1.classList.remove('translate-y-0', 'rotate-45');
        line2.classList.remove('translate-y-0', '-rotate-45', 'w-7', '-translate-x-1/2');

        line1.classList.add('-translate-y-[6px]', 'rotate-0');
        line2.classList.add('translate-y-[6px]', 'rotate-0', 'w-5', '-translate-x-1/3');
    }

    // Клік по бургеру відкриває/закриває
    burger.addEventListener('click', () => {
        if (drawer.classList.contains('-translate-x-full')) openDrawer();
        else closeDrawer();
    });

    // Клік по лінку в меню закриває drawer
    drawer.addEventListener('click', (e) => {
        if (e.target.tagName === 'A') closeDrawer();
    });

    // Клік по кнопці Close закриває drawer
    if (closeBtn) {
        closeBtn.addEventListener('click', closeDrawer);
    }

    // ===== DESKTOP MEGA MENU FOR "Категорії" =====
    const catLink = document.getElementById('categoriesLink');
    const megaMenu = document.getElementById('megaMenu');

    function placeMega() {
        const h = header.getBoundingClientRect().height;
        megaMenu.style.top = h + 'px';
    }
    placeMega();
    window.addEventListener('resize', placeMega);
    window.addEventListener('scroll', placeMega);

    // ====== Мінімальна логіка підміни кольорів/лого тільки під час відкритого мегаменю (без Liquid у JS) ======
    const headerEl = header; // сам header
    const headerInner = header.querySelector(':scope > div'); // контейнер з text-white|text-black із Liquid
    const headerLogo = header.querySelector('a img'); // логотип, який віддав Liquid

    // Дефолт беремо з DOM
    const isHero = !!(headerInner && headerInner.classList.contains('text-white')); // index/coop
    const isNkBlue = !!(headerInner && headerInner.className.includes('text-[#0066D6]'));
    const origLogoSrc = headerLogo ? headerLogo.getAttribute('src') : '';

    // Отримуємо пари шляхів лого (без Liquid, через заміну в назві файла)
    function deriveLogos(src) {
        let white = src || '';
        let black = src || '';
        if (src.includes('nk-header-logo-white')) {
            black = src.replace('nk-header-logo-white', 'nk-black-logo');
        } else if (src.includes('header-logo')) {
            black = src.replace('header-logo', 'black-logo');
        } else if (src.includes('black-logo')) {
            white = src.replace('black-logo', 'header-logo');
        } else if (src.includes('nk-black-logo')) {
            white = src.replace('nk-black-logo', 'nk-header-logo-white');
        }
        return { white, black };
    }
    const { white: LOGO_WHITE, black: LOGO_BLACK } = deriveLogos(origLogoSrc);

    function isDesktop() {
        return window.matchMedia('(min-width: 768px)').matches;
    }

    function activateHeaderForMega() {
        // фон: прозорий -> білий лише на десктопі
        headerEl.classList.remove('md:bg-transparent');
        headerEl.classList.add('md:bg-white');
        headerEl.classList.add('z-10');

        // текст → чорний (щоб контрастував на білому фоні)
        if (headerInner) {
            headerInner.classList.remove('text-white', 'text-black', 'text-[#0066D6]');
            if (isNkBlue) headerInner.classList.add('text-[#0066D6]');
            else headerInner.classList.add('text-black');
        }

        // логотип → чорний
        if (headerLogo) {
            if (isNkBlue && origLogoSrc) headerLogo.setAttribute('src', origLogoSrc);
            else if (LOGO_BLACK) headerLogo.setAttribute('src', LOGO_BLACK);
        }
    }

    function resetHeaderFromMega() {
        // повертаємо фон як було (прозорий на десктопі)
        headerEl.classList.remove('md:bg-white');
        headerEl.classList.add('md:bg-transparent');

        // повертаємо колір тексту рівно згідно з Liquid
        if (headerInner) {
            headerInner.classList.remove('text-white', 'text-black', 'text-[#0066D6]');
            if (isNkBlue) headerInner.classList.add('text-[#0066D6]');
            else if (isHero) headerInner.classList.add('text-white');
            else headerInner.classList.add('text-black');
        }

        // повертаємо логотип, який поставив Liquid
        if (headerLogo && origLogoSrc) headerLogo.setAttribute('src', origLogoSrc);
    }
    // =================================================================================================

    let hideTimer = null;
    const SHOW = () => {
        placeMega();
        megaMenu.classList.remove('opacity-0', 'pointer-events-none');
        megaMenu.classList.add('opacity-100', 'pointer-events-auto');
        catLink.setAttribute('aria-expanded', 'true');

        // активуємо білий хедер/чорний текст/чорний лого тільки на десктопі
        if (isDesktop()) activateHeaderForMega();
    };
    const HIDE = () => {
        megaMenu.classList.add('opacity-0', 'pointer-events-none');
        megaMenu.classList.remove('opacity-100', 'pointer-events-auto');
        catLink.setAttribute('aria-expanded', 'false');

        // повертаємо стан з DOM/Liquid
        if (isDesktop()) resetHeaderFromMega();
    };

    catLink.setAttribute('aria-haspopup', 'true');
    catLink.setAttribute('aria-expanded', 'false');

    const enter = () => {
        if (!isDesktop()) return;
        clearTimeout(hideTimer);
        SHOW();
    };
    const leave = () => {
        if (!isDesktop()) return;
        hideTimer = setTimeout(HIDE, 120);
    };

    catLink.addEventListener('mouseenter', enter);
    catLink.addEventListener('mouseleave', leave);
    megaMenu.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        clearTimeout(hideTimer);
        SHOW();
    });
    megaMenu.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        hideTimer = setTimeout(HIDE, 120);
    });

    catLink.addEventListener('focus', enter);
    catLink.addEventListener('blur', leave);
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') HIDE();
    });

    document.addEventListener('click', (e) => {
        if (!isDesktop()) return;
        if (!megaMenu.contains(e.target) && e.target !== catLink) HIDE();
    });
})();

// Lang Selector_____________________________________________________________________________
(function () {
    const btn = document.getElementById('langBtn');
    const chevron = document.getElementById('langChevron');
    const menu = document.getElementById('langMenu');
    const current = document.getElementById('langCurrent');

    function openLang() {
        btn.setAttribute('aria-expanded', 'true');
        menu.classList.remove('opacity-0', 'scale-95', 'pointer-events-none');
        chevron.classList.add('rotate-180');
        const first = menu.querySelector('button');
        first && first.focus({ preventScroll: true });
    }
    function closeLang() {
        btn.setAttribute('aria-expanded', 'false');
        menu.classList.add('opacity-0', 'scale-95', 'pointer-events-none');
        chevron.classList.remove('rotate-180');
    }
    function toggleLang() {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        expanded ? closeLang() : openLang();
    }

    btn.addEventListener('click', toggleLang);

    menu.addEventListener('click', (e) => {
        const b = e.target.closest('button[data-lang]');
        if (!b) return;
        current.textContent = b.dataset.lang;
        closeLang();
        btn.focus();
    });

    document.addEventListener('click', (e) => {
        if (!btn.contains(e.target) && !menu.contains(e.target)) closeLang();
    });
})();


